/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 */

import type { Listable } from '@zcode/state-type'
import React from 'react'
import {
  getPercentMedianRentFromRecentAverages,
  isSweetDealListCard,
} from '../../../../../detail/Content/SweetDeal/helpers'

export interface Props {
  listable: Listable
  recentAverages: any
}

export const SweetDealPercent = ({ listable, recentAverages }: Props) => {
  const { isBuilding, propertyType } = listable
  const percentMedianRent = getPercentMedianRentFromRecentAverages({
    bedrooms: listable?._data?.max_bedrooms,
    price: listable?._data?.max_price,
    recentAverages,
  })
  const sweetDeal = isSweetDealListCard(isBuilding, propertyType, percentMedianRent)

  if (sweetDeal && percentMedianRent) {
    return (
      <span className="text-blue-800 font-normal text-xs leading-5 ml-2">
        {Math.abs(100 - percentMedianRent)}% below avg price
      </span>
    )
  }
  return null
}
